import { useState, useContext, useCallback } from "react";
import { GlobalContext } from "../../Context/GlobalContext";
import { toast } from "react-toastify";

const useOrderVendors = () => {
  const { api, userID } = useContext(GlobalContext);

  const [loading, setLoading] = useState(false);
  const [purchaseList, setPurchaseList] = useState([]);

  const postRequest = useCallback(
    async (endpoint, body) => {
      const response = await api.post(endpoint, body);
      return response?.data;
    },
    [api]
  );

  /* Get Vendor Purchase List */
  const getVendorPurchaseList = async (
    startDate,
    endDate
  ) => {
    if (!startDate || !endDate) return;

    try {
      setLoading(true);

      const data = await postRequest(
        "/Inventory/v1.0/getVendorPurchaseDetails",
        {
          userid: userID,
          fromDate: startDate,
          toDate: endDate,
        }
      );

      if (data?.responseCode === "00") {
        setPurchaseList(data?.response || []);
      } else {
        setPurchaseList([]);
        toast.error(
          data?.responseMessage ||
            "Failed to fetch list"
        );
      }

      return data;
    } catch (error) {
      toast.error(
        error?.response?.data?.responseMessage ||
          "Server Error"
      );

      setPurchaseList([]);

      return null;
    } finally {
      setLoading(false);
    }
  };

  /* Add Vendor Purchase */
  const addVendorPurchase = async (data) => {
    try {
      setLoading(true);

      const payload = {
        userid: userID,
        ...data,
        amount: String(data.amount),
      };

      const responseData = await postRequest(
        "/Inventory/v1.0/insertVendorPurchaseDetails",
        payload
      );

      if (responseData?.responseCode === "00") {
        toast.success(
          responseData?.responseMessage
        );
      } else {
        toast.warning(
          responseData?.responseMessage ||
            "Could not add purchase"
        );
      }

      return responseData;
    } catch (error) {
      toast.error(
        error?.response?.data?.responseMessage ||
          "Network Error"
      );

      return null;
    } finally {
      setLoading(false);
    }
  };

  /* Process Vendor Payment */
  const processVendorPayment = async ({
    vendorId,
    purchaseId,
    amount,
    mode,
  }) => {
    try {
      setLoading(true);

      const data = await postRequest(
        "/Transactions/v1.0/processVendorPayment",
        {
          userid: userID,
          vendorId,
          purchaseId,
          amount: String(amount),
          mode,
        }
      );

      if (data?.responseCode === "00") {
        toast.success(
          data?.responseMessage ||
            "Payment Processed"
        );
      } else {
        toast.error(
          data?.responseMessage ||
            "Payment Failed"
        );
      }

      return data;
    } catch (error) {
      toast.error(
        error?.response?.data?.responseMessage ||
          "Payment Error"
      );

      return null;
    } finally {
      setLoading(false);
    }
  };

  return {
    purchaseList,
    loading,
    getVendorPurchaseList,
    addVendorPurchase,
    processVendorPayment,
  };
};

export default useOrderVendors;